import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventNextPage } from './event-next';

@NgModule({
  declarations: [
    EventNextPage,
  ],
  imports: [
    IonicPageModule.forChild(EventNextPage),
  ],
  entryComponents: [
    EventNextPage
  ]
})
export class EventNextPageModule {}



// WEBPACK FOOTER //
// ./src/pages/event-next/event-next.module.ts